// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__W7TK9","iconContainer":"Item_iconContainer__mlt8d","label":"Item_label__IfA4b"};